import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { isSupabaseConfigured } from '@/config';
import { useAuth } from '@/lib/auth/AuthProvider';
import { getPotmTally, votePotm } from '@/lib/data/provider';

/** The live Player-of-the-Match tally for a fixture. Polls while the match is
 *  live so the bars move with the community; static once finished. */
export function usePotmTally(fixtureId: string, live: boolean, enabled = true) {
  const { userId } = useAuth();
  return useQuery({
    queryKey: ['potm', 'tally', fixtureId, userId ?? 'anon'],
    queryFn: () => getPotmTally(fixtureId),
    enabled: isSupabaseConfigured && enabled,
    refetchInterval: live ? 20000 : false,
  });
}

/** Cast / change the caller's PotM vote, then refresh the tally. */
export function useVotePotm(fixtureId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (playerId: string) => votePotm(fixtureId, playerId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['potm', 'tally', fixtureId] }),
  });
}
